import React from 'react';
import styled from 'styled-components';

import { breakpoints, colors } from '../../../constants';
import { pushToDataLayer } from '../../../utils';
import { LinkButton } from '../LinkButton';
import { Title } from '../Title';

interface IProps {
    className?: string;
}

const BaseActionBanner = ({ className }: IProps) => {
    const handleButtonClick = () => {
        pushToDataLayer('Klik Bekijk onze acties button', '');
    };

    return (
        <div className={className}>
            <Title>Bij Pearle is er alijd een passende actie</Title>
            <LinkButton
                href="https://www.pearle.nl/acties"
                onClick={handleButtonClick}
                target="_blank"
                rel="noopener noreferrer"
            >
                Bekijk onze acties
            </LinkButton>
        </div>
    );
};

export const ActionBanner = styled(BaseActionBanner)`
    background-color: ${colors.orangeLight};
    color: ${colors.white};
    line-height: 1.5;
    padding: 30px;

    ${Title} {
        margin-bottom: 40px;
    }

    @media (${breakpoints.smallMin}) {
        padding: 40px;
    }
`;
